<div class="page full-height gray-font-color font-family bodyBackground">
  <div class="header-navigation-back">
    <mat-icon data-test="back-arrow-icon" (click)="navigateBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title">Shipment Details</span>
  </div>
  @if (isContentReady) {
    <div class="full-height">
      <div class="section">
        <div class="shipment-meta-container">
          <div class="shipment-id-container">
            <div class="shipment-id">{{ shipment.shipmentID || '-' }}</div>
            <br />
            @if (!isConfirmationPending) {
              <div class="shipment-type">{{ shipmentType }}</div>
            }
          </div>
          <div class="shipment-status-container">
            <div [ngClass]="[getStatusClass(), 'status-tag']">
              {{ shipment.status === 'out for delivery' ? 'In Transit' : shipment.status | titlecase }}
            </div>
          </div>
        </div>
        <div class="route-container">
          <div class="route-section">
            <div class="route-visual">
              <div class="route-point from-point">
                <mat-icon class="route-icon">radio_button_checked</mat-icon>
              </div>
              <div class="route-line"></div>
              <div class="route-point to-point">
                <mat-icon class="route-icon">location_on</mat-icon>
              </div>
            </div>
            <div class="route-info">
              <div class="route-location">
                <span class="location-label">From</span>
                <div class="location-city">{{ shipment.origin || '-' }}</div>
                <div class="location-address">{{ shipment.pickup.streetAddress || '-' }}</div>
                <div class="location-datetime">{{ pickupFormattedDateTime || '-' }}</div>
              </div>
              <div class="route-location">
                <span class="location-label">To</span>
                <div class="location-city">{{ shipment.destination || '-' }}</div>
                <div class="location-address">{{ shipment.delivery.streetAddress || '-' }}</div>
                <div class="location-datetime">{{ deliveryFormattedDateAndTime || '-' }}</div>
              </div>
            </div>
          </div>
        </div>
        @if (shipment.status !== 'confirmation pending') {
          <div >
            <div class="margin-top-md">
              <button
                mat-button
                class="btn-accept"
                (click)="onChangeShipmentStatus()"
                [disabled]="disableChangeStatus()"
                data-test="change-status-button"
                >
                Change Status
              </button>
              @if (shipment.status !== 'delivered') {
                <div class="margin-top-md contact-row">
                  <div (click)="onAddShipmentComment()"><mat-icon svgIcon="comments" data-test="comment"></mat-icon></div>
                  <div (click)="onAddShipmentPhoto()"><mat-icon svgIcon="camera" data-test="camera"></mat-icon></div>
                  <div (click)="getContact()"><mat-icon svgIcon="phonecall" data-test="phonecall"></mat-icon></div>
                </div>
              }
            </div>
          </div>
        }
      </div>
      @if (isContentReady) {
        <div class="shipment-content">
          @if (!isConfirmationPending) {
            <mat-tab-group
              (selectedTabChange)="tabChanged($event)"
              data-test="content-tabs"
              [selectedIndex]="tabIndex"
              >
              <mat-tab label="DOCUMENTS" data-test="documents-tab">
                @if (isProcessingDocuments) {
                  <div class="spinner-container">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }
                @if (!isProcessingDocuments) {
                  <div class="detail-panel-body no-scroll">
                    <app-shipment-sub-documents
                      [shipmentId]="shipment.id"
                      [shipmentDocuments]="shipmentDocuments"
                      (updateShipmentDocuments)="getShipmentDocuments()"
                    ></app-shipment-sub-documents>
                  </div>
                }
              </mat-tab>
            </mat-tab-group>
          }
          @if (isConfirmationPending) {
            <div>
              <app-shipment-sub-detail [shipment]="shipment"></app-shipment-sub-detail>
            </div>
          }
        </div>
      }
      @if (isConfirmationPending) {
        <div class="margin-sm">
          <button mat-button class="btn-accept" (click)="confirmShipment()" data-test="confirm-button">Confirm</button>
        </div>
      }
    </div>
  }
</div>
